var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 87,
    viewBox: "0 0 85 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3325 3.9375C63.9144 3.9375 81.4092 21.4333 81.4092 43.0142C81.4092 64.595 63.9144 82.0909 42.3325 82.0909C20.7507 82.0909 3.25586 64.5961 3.25586 43.0142C3.25586 21.4323 20.7517 3.9375 42.3325 3.9375ZM42.3325 5.94529C21.8592 5.94529 5.26365 22.5408 5.26365 43.0142C5.26365 63.4875 21.8592 80.0831 42.3325 80.0831C62.8059 80.0831 79.4014 63.4875 79.4014 43.0142C79.4014 22.5408 62.8059 5.94634 42.3325 5.94634V5.94529Z",
    fill: "#42536C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1582 8.85398L59.1656 8.85713C71.7487 15.0698 80.4046 28.0274 80.4067 43.0095V43.0127H81.4111H84.3329C84.0331 41.1164 83.3179 38.5406 82.6785 36.8242C82.4839 36.2825 82.2935 35.8103 82.1221 35.4517C82.1221 35.4517 82.12 35.4517 82.1189 35.4506C81.1377 35.0899 80.4582 34.3347 80.1995 33.3229C78.584 26.9903 75.4214 21.2772 71.1387 16.6075C70.7327 16.1584 70.3078 15.7187 69.8671 15.2844C69.8461 15.2633 69.824 15.2423 69.803 15.2213C69.7651 15.1834 69.7262 15.1466 69.6873 15.1087C69.2603 14.6901 68.8238 14.281 68.3789 13.8824L68.3042 13.8151C67.6826 13.2524 67.569 12.6781 67.5732 12.1144C65.8494 10.1729 62.8235 7.79066 60.1447 6.26562L59.5179 7.90846L59.1582 8.85293V8.85398Z",
    fill: "url(#paint0_linear_318_4802)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26031 43.0095C4.26031 43.0011 4.26031 42.9927 4.26031 42.9832C4.27188 28.0095 12.9288 15.0603 25.5077 8.85293L25.147 7.90846L24.5202 6.26562C21.8413 7.79066 18.8155 10.1729 17.0917 12.1144C17.0959 12.6781 16.9823 13.2524 16.3607 13.8151L16.2871 13.8824C15.8443 14.2778 15.411 14.6849 14.9871 15.0993C14.9471 15.1382 14.9072 15.1781 14.8661 15.2171C14.8451 15.2381 14.823 15.2591 14.802 15.2802C14.3613 15.7145 13.9343 16.1552 13.5273 16.6064C9.2435 21.2762 6.08194 26.9903 4.4654 33.3229C4.20667 34.3357 3.52724 35.0899 2.54596 35.4506C2.54491 35.4506 2.54386 35.4506 2.54281 35.4517C2.37137 35.8103 2.18101 36.2825 1.98643 36.8242C1.34697 38.5417 0.630728 41.1174 0.332031 43.0127H4.25821V43.0095H4.26031Z",
    fill: "url(#paint1_linear_318_4802)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26313 43.0137C5.26313 22.5403 21.8587 5.94477 42.332 5.94477C62.8054 5.94477 79.4009 22.5403 79.4009 43.0137C79.4009 63.487 62.8054 80.0826 42.332 80.0826C21.8587 80.0826 5.26313 63.487 5.26313 43.0137ZM42.332 81.087C63.3596 81.087 80.4053 64.0413 80.4053 43.0137C80.4053 21.986 63.3596 4.94141 42.332 4.94141C21.3044 4.94141 4.25977 21.9871 4.25977 43.0137C4.25977 64.0402 21.3055 81.087 42.3331 81.087H42.332Z",
    fill: "url(#paint2_linear_318_4802)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5215 6.26842L25.508 8.85573C30.5817 6.35256 36.2927 4.94322 42.3329 4.94322V0C39.1587 0.480649 35.6027 1.4735 33.6791 2.54313C33.3541 3.53388 32.9849 4.25222 32.1866 4.91693C31.8101 5.23035 31.3505 5.49013 30.8362 5.64894C30.3356 5.8046 29.8307 5.96868 29.3374 6.15378C28.6443 6.41357 28.1595 6.26317 27.6694 5.91293C26.8963 5.8656 25.487 6.13275 24.5215 6.26842Z",
    fill: "url(#paint3_linear_318_4802)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1454 6.26842L59.1588 8.85573C54.0852 6.35256 48.3742 4.94322 42.334 4.94322V0C45.5082 0.480649 49.0641 1.4735 50.9878 2.54313C51.3128 3.53388 51.6819 4.25222 52.4802 4.91693C52.8567 5.23035 53.3163 5.49013 53.8307 5.64894C54.3313 5.8046 54.8361 5.96868 55.3294 6.15378C56.0225 6.41357 56.5074 6.26317 56.9975 5.91293C57.7705 5.8656 59.1798 6.13275 60.1454 6.26842Z",
    fill: "url(#paint4_linear_318_4802)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1582 77.1743L59.1656 77.1712C71.7487 70.9585 80.4046 58.0009 80.4067 43.0188V43.0156H81.4111H84.3329C84.0331 44.9119 83.3179 47.4877 82.6785 49.2041C82.4839 49.7458 82.2935 50.218 82.1221 50.5766C82.1221 50.5766 82.12 50.5766 82.1189 50.5777C81.1377 50.9384 80.4582 51.6936 80.1995 52.7054C78.584 59.038 75.4214 64.7511 71.1387 69.4208C70.7327 69.8699 70.3078 70.3096 69.8671 70.7439C69.8461 70.765 69.824 70.786 69.803 70.807C69.7651 70.8449 69.7262 70.8817 69.6873 70.9196C69.2603 71.3382 68.8238 71.7473 68.3789 72.1459L68.3042 72.2132C67.6826 72.7759 67.569 73.3502 67.5732 73.9139C65.8494 75.8554 62.8235 78.2376 60.1447 79.7627L59.5179 78.1198L59.1582 77.1754V77.1743Z",
    fill: "url(#paint5_linear_318_4802)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26031 43.0188C4.26031 43.0272 4.26031 43.0356 4.26031 43.0451C4.27188 58.0188 12.9288 70.968 25.5077 77.1754L25.147 78.1198L24.5202 79.7627C21.8413 78.2376 18.8155 75.8554 17.0917 73.9139C17.0959 73.3502 16.9823 72.7759 16.3607 72.2132L16.2871 72.1459C15.8443 71.7505 15.411 71.3445 14.9871 70.929C14.9471 70.8901 14.9072 70.8502 14.8661 70.8112C14.8451 70.7902 14.823 70.7692 14.802 70.7481C14.3613 70.3138 13.9343 69.8731 13.5273 69.4219C9.2435 64.7521 6.08194 59.038 4.4654 52.7054C4.20667 51.6926 3.52724 50.9384 2.54596 50.5777C2.54491 50.5777 2.54386 50.5777 2.54281 50.5766C2.37137 50.218 2.18101 49.7458 1.98643 49.2041C1.34697 47.4866 0.630728 44.9109 0.332031 43.0156H4.25821V43.0188H4.26031Z",
    fill: "url(#paint6_linear_318_4802)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5215 79.7631L25.508 77.1758C30.5817 79.6789 36.2927 81.0883 42.3329 81.0883V86.0315C39.1587 85.5509 35.6027 84.558 33.6791 83.4884C33.3541 82.4976 32.9849 81.7793 32.1866 81.1146C31.8101 80.8012 31.3505 80.5414 30.8362 80.3826C30.3356 80.2269 29.8307 80.0628 29.3374 79.8777C28.6443 79.619 28.1595 79.7683 27.6694 80.1186C26.8963 80.1659 25.487 79.8988 24.5215 79.7631Z",
    fill: "url(#paint7_linear_318_4802)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1454 79.7631L59.1588 77.1758C54.0852 79.6789 48.3742 81.0883 42.334 81.0883V86.0315C45.5082 85.5509 49.0641 84.558 50.9878 83.4884C51.3128 82.4976 51.6819 81.7793 52.4802 81.1146C52.8567 80.8012 53.3163 80.5414 53.8307 80.3826C54.3313 80.2269 54.8361 80.0628 55.3294 79.8777C56.0225 79.619 56.5074 79.7683 56.9975 80.1186C57.7705 80.1659 59.1798 79.8988 60.1454 79.7631Z",
    fill: "url(#paint8_linear_318_4802)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9307 8.18439C31.6394 6.09982 36.8498 4.94079 42.3315 4.94079V0.359375C42.2568 1.0388 42.2305 1.72454 42.1064 2.39661C41.956 3.21803 41.387 3.68395 40.696 3.97108C40.3984 4.09519 40.0787 4.18564 39.7589 4.2561C34.7789 5.36991 31.4059 6.02409 26.9297 8.18439H26.9307Z",
    fill: "url(#paint9_linear_318_4802)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3848 19.5064C15.8913 15.0459 20.3728 11.3879 25.5074 8.85426L25.1477 7.91189L24.6334 6.5625C24.7218 7.03789 24.8922 7.5848 24.7207 8.12435C24.6208 8.43777 24.4052 8.74803 23.9919 9.04042C23.6153 9.30651 23.2188 9.54526 22.8297 9.79347C18.263 12.6931 15.2666 15.1658 12.3848 19.5064Z",
    fill: "url(#paint10_linear_318_4802)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87888 42.7502C2.26465 42.8669 1.60836 42.9384 0.980469 43.0163H4.25982V42.9868C4.26298 38.6662 4.98553 34.515 6.31494 30.6445C4.85511 34.3519 4.58061 36.3398 4.03054 40.8244C3.92221 41.711 3.97375 42.3515 3.25751 42.6429C3.14917 42.6871 3.02507 42.7228 2.87888 42.7502Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7876 42.7502C82.4018 42.8669 83.0581 42.9384 83.686 43.0163H80.4067V42.9868C80.4035 38.6662 79.681 34.515 78.3516 30.6445C79.8114 34.3519 80.0848 36.3398 80.636 40.8244C80.7443 41.711 80.6927 42.3515 81.409 42.6429C81.5163 42.6871 81.6414 42.7228 81.7876 42.7502Z",
    fill: "url(#paint11_linear_318_4802)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_4802",
    x1: 76.6141,
    y1: 17.0639,
    x2: 66.9979,
    y2: 33.7194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_4802",
    x1: 2.15471,
    y1: 41.8694,
    x2: 22.0464,
    y2: 7.41624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_4802",
    x1: 42.332,
    y1: 5.94583,
    x2: 42.332,
    y2: 80.0826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_4802",
    x1: 24.5215,
    y1: 4.42786,
    x2: 42.3329,
    y2: 4.42786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_4802",
    x1: 51.2391,
    y1: 8.85573,
    x2: 51.2391,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_4802",
    x1: 76.7129,
    y1: 69.1358,
    x2: 66.8539,
    y2: 52.0607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_4802",
    x1: 2.30932,
    y1: 44.4271,
    x2: 22.1306,
    y2: 78.7583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_4802",
    x1: 24.5215,
    y1: 81.6036,
    x2: 42.3329,
    y2: 81.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_4802",
    x1: 0.334492,
    y1: 77.1758,
    x2: 0.439667,
    y2: 86.0315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_4802",
    x1: 26.9307,
    y1: 4.27188,
    x2: 42.3315,
    y2: 4.27188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C66A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_4802",
    x1: 12.3848,
    y1: 13.035,
    x2: 25.5074,
    y2: 13.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C66A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_4802",
    x1: 81.0188,
    y1: 43.0152,
    x2: 81.0188,
    y2: 30.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C66A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDEF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialCircle);
export default __webpack_public_path__ + "static/media/social-circle.e219d9cd99ca0d2c62dbaf37970e80db.svg";
export { ForwardRef as ReactComponent };